import useAppDispatch from '../../../hooks/useAppDispatch';
import { useTranslation } from '../../../hooks/useTranslation';
import { Product } from '../../../models/Product';
import ProductActionButton from './ProductActionButton';
import './ProductActionButtons.less';
export type ProductActionButtonsProps = {
    className?: string;
    product: Product;
};

const ProductActionButtons = ({
    className = '',
    product
}: ProductActionButtonsProps) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    return (
        <div className={`bri-ProductActionButtons ${className}`}>
            <ProductActionButton
                iconId="outfit"
                onClick={() =>
                    dispatch.featureState.startFeature({
                        featureType: 'product-mix-and-match',
                        productId: product.productId
                    })
                }
            >
                {t('PRODUCT_DETAIL_BUTTON_MIX_AND_MATCH')}
            </ProductActionButton>
            <ProductActionButton
                iconId="similar"
                onClick={() =>
                    dispatch.featureState.startFeature({
                        featureType: 'product-search-similar',
                        similarToProductIds: [product.productId]
                    })
                }
            >
                {t('PRODUCT_DETAIL_BUTTON_SIMILAR')}
            </ProductActionButton>
            <ProductActionButton
                iconId="join"
                onClick={() =>
                    dispatch.featureState.startFeature({
                        featureType: 'product-search-combinations',
                        combinationWithProductIds: [product.productId]
                    })
                }
            >
                {t('PRODUCT_DETAIL_BUTTON_COMBINATIONS')}
            </ProductActionButton>
            <ProductActionButton iconId="loyalty" href={product.url}>
                {t('PRODUCT_DETAIL_BUTTON_GO_TO_PRODUCT')}
            </ProductActionButton>
        </div>
    );
};

export default ProductActionButtons;
